export function getGracePeriodEndDate(graceDate, days) {
    if (!graceDate ||
        days === null ||
        days === undefined ||
        Number.isNaN(Number(days))) {
        return undefined;
    }
    var date = new Date(graceDate);
    if (Number.isNaN(date.getTime()))
        return undefined;
    date.setDate(date.getDate() + Number(days));
    return date;
}
export function formatDateBR(date) {
    var dd = date.getDate().toString().padStart(2, "0");
    var mm = (date.getMonth() + 1).toString().padStart(2, "0");
    return "".concat(dd, "/").concat(mm, "/").concat(date.getFullYear());
}
export function formatGracePeriodEnd(graceDate, days) {
    var date = getGracePeriodEndDate(graceDate, days);
    return date ? formatDateBR(date) : null;
}
export function parseISODateLocal(isoDate) {
    var _a = isoDate.split("-").map(Number), year = _a[0], month = _a[1], day = _a[2];
    return new Date(year, month - 1, day);
}
